// extracted by mini-css-extract-plugin
module.exports = {"feedbackForm":"index-feedbackForm-2hfsf","feedbackFormItem":"index-feedbackFormItem-3tv3W"};